// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { grpc } from "../../../app/rpc/executor"
import { showSnackBar } from "../../snackbar/actions"
import { timesheetFieldClient } from "../../../app/rpc/client"
import {
  ListTimesheetFieldsRequest,
  ListTimesheetFieldsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListTimesheetFieldsRpc = (request: ListTimesheetFieldsRequest) => Observable<ListTimesheetFieldsResponse>

export const listTimesheetFields = (listTimesheetFieldsRpc: ListTimesheetFieldsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listTimesheetFields.match),
      mergeMap(action => of(action.payload)
        .pipe(
          mergeMap(listTimesheetFieldsRpc),
          map(t => t.toObject().timesheetFieldsList),
          map(Slice.setTimesheetFields),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_timesheet_fields_failed",
              message: "Failed to load timesheet fields. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const listTimesheetFieldsRpc = (request: ListTimesheetFieldsRequest): Observable<ListTimesheetFieldsResponse> =>
  grpc(() => timesheetFieldClient.listTimesheetFields(request, null))

export default listTimesheetFields(listTimesheetFieldsRpc)
